<template>
  <div class="view">
    <div class="content">
      <h2 class="ui inverted header">Log in with</h2>
      <div class="socials">
        <a class="ui large label" @click="thirdPartyLogin('github')"><i class="github icon" />Github</a>
        <a class="ui large label" @click="thirdPartyLogin('bitbucket')"><i class="bitbucket icon" />Bitbucket</a>
        <a class="ui large label" @click="thirdPartyLogin('google')"><i class="google icon" />Google</a>
        <a class="ui large label" @click="thirdPartyLogin('facebook')"><i class="facebook icon" />Facebook</a>
      </div>
      <sui-segment :loading="loading">
        <sui-form :error="hasError" @submit.prevent="submit">
          <sui-form-field>
            <sui-input type="text" ref="email" v-model.trim="email" placeholder="Email" icon="user" icon-position="left" autocomplete="email" required />
          </sui-form-field>
          <sui-form-field>
            <sui-input type="password" ref="password" v-model.trim="password" placeholder="Password" icon="lock" icon-position="left" autocomplete="current-password" required />
          </sui-form-field>
          <sui-button size="large" color="blue" fluid>Log in</sui-button>
          <div class="reset">
            Forgot your password? <router-link :to="{path: '/user/recovery', query: {email}}" data-goal="USER_RESET_OPEN">Reset</router-link>
          </div>
          <sui-message error>
            {{error}}
          </sui-message>
        </sui-form>
      </sui-segment>
      <sui-message>
        New to us? <router-link :to="{path: '/user/register', query: {email}}" data-goal="USER_SIGNUP_OPEN">Sign up</router-link>
      </sui-message>
      <small>© D2C, 2017-2020. All rights reserved.</small>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import utils from '@/utils'

  export default {
    name: 'AccountLogin',
    data() {
      return {
        email: '',
        password: '',
        loading: false,
        error: null,
      }
    },
    computed: {
      hasError() {
        return Boolean(this.error)
      }
    },
    methods: {
      submit() {
        this.loading = true
        this.error = null
        utils.reachGoal('USER_SIGNIN_EMAIL')
        api.login(this.email, this.password).then(data => {
          utils.reachGoal('USER_SIGNIN_SUCCESS')
          this.$store.dispatch('login', data.member.token)
        }).catch(error => {
          utils.reachGoal('USER_SIGNIN_FAIL')
          this.error = error
        }).finally(() => {
          this.loading = false
        })
      },
      thirdPartyLogin(method) {
        utils.reachGoal(`USER_SIGNIN_${method.toUpperCase()}`)
        api.thirdPartyLogin(method)
      },
    },
    mounted() {
      this.email = this.$route.query.email
      this.$nextTick(() => {
        if (this.email) {
          this.$refs.password.$refs.input.focus()
        } else {
          this.$refs.email.$refs.input.focus()
        }
      })
    },
  }
</script>

<style scoped>
  .view { display: flex; align-items: center; justify-content: center; text-align: center; }
  .socials { display: flex; }
  .reset { margin-top: .5em; color: #999; }
  small { color: #eee; }
</style>
